import {useFetcher} from '@remix-run/react'

export function RestartAuthFlow() {
  const fetcher = useFetcher()

  return (
    <div className="rounded-lg bg-white/90 p-4 p-4 shadow-2xl backdrop-blur-sm">
      <h1 className="font-title text-xl font-medium text-gray-600">
        Check your email.
      </h1>
      <p className="mt-2 font-body text-gray-600">
        We've just emailed you, follow the instructions in the email.
      </p>
      <fetcher.Form method="POST" action="/restart-auth-flow">
        <p className="mt-2 font-body text-gray-600">
          If after 10 minutes you still haven't received your email,{' '}
          <button type="submit" className="underline">
            click here
          </button>{' '}
          to start again.
        </p>
      </fetcher.Form>
      <p className="mt-2 font-body text-gray-600">
        Occasionally email filter systems may prevent you from receiving an
        email. If you do not receive an email, please contact us at{' '}
        <a href="mailto:sias@dragonflyintelligence.com">
          sias@dragonflyintelligence.com
        </a>
      </p>
    </div>
  )
}
